import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { isKeyArrowVertical, isKeyEnter, isKeySpace, someKeys } from "../../../lib/events/keyboard/identifiers";
import * as LayoutEvents from "../../../lib/LayoutEvents";
import { tabListener } from "../../../lib/events/tabListener";
import { PopupMenu } from "../../../internal/PopupMenu";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { MenuKebabIcon } from "../../../internal/icons/16px";
import { isTestEnv } from "../../../lib/currentEnvironment";
import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../Kebab.styles";
export var Kebab = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Kebab, _React$Component);

  function Kebab() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      opened: false,
      focusedByTab: false,
      anchor: null
    };
    _this.theme = void 0;
    _this.listener = {
      remove: function remove() {
        return undefined;
      }
    };

    _this.renderCaption = function (captionProps) {
      var _cx;

      var disabled = _this.props.disabled;

      var handleCaptionKeyDown = function handleCaptionKeyDown(event) {
        if (!disabled) {
          _this.handleCaptionKeyDown(event, captionProps.openMenu);
        }
      };

      var handleCaptionClick = function handleCaptionClick() {
        if (!disabled) {
          captionProps.toggleMenu();
        }
      };

      return /*#__PURE__*/React.createElement("span", {
        tabIndex: disabled ? -1 : 0,
        onClick: handleCaptionClick,
        onKeyDown: handleCaptionKeyDown,
        onFocus: _this.handleFocus,
        onBlur: _this.handleBlur,
        className: cx((_cx = {}, _cx[styles.kebab(_this.theme)] = true, _cx[styles.opened(_this.theme)] = captionProps.opened, _cx[styles.disabled()] = disabled, _cx[styles.focused(_this.theme)] = _this.state.focusedByTab, _cx))
      }, _this.renderIcon());
    };

    _this.handleCaptionKeyDown = function (e, openMenu) {
      if (someKeys(isKeyEnter, isKeySpace, isKeyArrowVertical)(e)) {
        e.preventDefault();
        openMenu(true);
      }
    };

    _this.handleChangeMenuState = function (isOpened, restoreFocus) {
      _this.setState({
        opened: isOpened,
        focusedByTab: !isOpened && restoreFocus
      }, function () {
        if (_this.props.disabled) {
          return;
        }

        if (_this.state.opened) {
          _this.props.onOpen();
        } else {
          _this.props.onClose();
        }
      });
    };

    _this.handleFocus = function () {
      if (!_this.props.disabled) {
        // focus event fires before keyDown eventlistener
        // so we should check tabPressed in async way
        requestAnimationFrame(function () {
          if (tabListener.isTabPressed) {
            _this.setState({
              focusedByTab: true
            });
          }
        });
      }
    };

    _this.handleBlur = function () {
      _this.setState({
        focusedByTab: false
      });
    };

    return _this;
  }

  var _proto = Kebab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    /** addListener'у нужен колбэк в аргумент */
    this.listener = LayoutEvents.addListener(function () {
      return undefined;
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.listener.remove();
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: ThemeFactory.create({
          popupPinOffset: theme.kebabPinOffset,
          popupMargin: theme.kebabMargin,
          popupPinSize: theme.kebabPinSize
        }, theme)
      }, _this2.renderMain());
    });
  };

  _proto.renderMain = function renderMain() {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        positions = _this$props.positions;
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement(PopupMenu, {
      popupHasPin: true,
      positions: positions,
      onChangeMenuState: this.handleChangeMenuState,
      caption: this.renderCaption,
      disableAnimations: this.props.disableAnimations
    }, !disabled && this.props.children));
  };

  _proto.renderIcon = function renderIcon() {
    var _cx2;

    return /*#__PURE__*/React.createElement("div", {
      className: cx((_cx2 = {}, _cx2[styles.icon()] = true, _cx2[styles.iconsmall()] = this.props.size === 'small', _cx2[styles.iconmedium()] = this.props.size === 'medium', _cx2[styles.iconlarge()] = this.props.size === 'large', _cx2))
    }, this.props.icon);
  };

  return Kebab;
}(React.Component);
Kebab.__KONTUR_REACT_UI__ = 'Kebab';
Kebab.propTypes = {};
Kebab.defaultProps = {
  onOpen: function onOpen() {
    return undefined;
  },
  onClose: function onClose() {
    return undefined;
  },
  positions: ['bottom left', 'bottom right', 'top left', 'top right'],
  size: 'small',
  disableAnimations: isTestEnv,
  icon: /*#__PURE__*/React.createElement(MenuKebabIcon, null)
};
Kebab.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  menuMaxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Размер кебаба small 14px | large 20px
   */
  size: PropTypes.string,

  /**
   * Коллбек, вызывающийся перед закрытием кебаба
   */
  onClose: PropTypes.func,

  /**
   * Коллбек, вызывающийся перед открытием кебаба
   */
  onOpen: PropTypes.func
};